import React from "react";

import { Icon } from "../../../components/Icon/Icon";
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";

import three353 from "../../../assets/images/Infinite353/three353.png";
import three353Two from "../../../assets/images/Infinite353/three353-two.png";
import productWavesTop from "../../../assets/images/Infinite353/product-waves-top.png";
import office from "../../../assets/images/office.png";
import roundLines from "../../../assets/images/round-lines.png";
import qualcomm from "../../../assets/images/qualcomm-5g-sdx65.png";
import topImage from "../../../assets/images/top-left-image.png";
import bottomImage from "../../../assets/images/bottom-right-image.png";
import FlickitySlider from "../../../components/FlickitySlider/FlickitySlider";
import product353Wallpaper from "../../../assets/images/Infinite353/353-wallpaper.png";
import allProducts from "../../../assets/images/all-products-two.jpg";
import wifi6 from "../../../assets/images/wifi-6.png";
import product353 from "../../../assets/images/Infinite353/353.png";
import productPorts from "../../../assets/images/product-ports.jpg";
import OtherProducts from "../OtherProducts/OtherProducts";

import cs from "classnames";

import "./Infinite353.scss";

const Infinite353 = () => {
  const navigate = useNavigate();
  const [productTitleRef, productTitleVisibility] = useInView();
  const [productImageRef, productImageVisibility] = useInView();
  const [sixCartTitleRef, sixCartTitleVisibility] = useInView();
  const [cartOneRef, cartOneVisibility] = useInView();
  const [cartTwoRef, cartTwoVisibility] = useInView();
  const [cartThreeRef, cartThreeVisibility] = useInView();
  const [cartFourRef, cartFourVisibility] = useInView();
  const [cartFiveRef, cartFiveVisibility] = useInView();
  const [cartSixRef, cartSixVisibility] = useInView();
  const [roundLinesImageRef, roundLinesImageVisibility] = useInView();
  const [roundLinesDescriptionRef, roundLinesDescriptionVisibility] =
    useInView();
  const [wifiSixTitleRef, wifiSixTitleVisibility] = useInView();
  const [wifiSixSubTitleRef, wifiSixSubTitleVisibility] = useInView();
  const [wifiSixImageRef, wifiSixImageVisibility] = useInView();
  const [qualcommDescriptionOneRef, qualcommDescriptionOneVisibility] =
    useInView();
  const [qualcommImageRef, qualcommImageVisibility] = useInView();
  const [qualcommDescriptionTwoRef, qualcommDescriptionTwoVisibility] =
    useInView();
  const [twoImagesTitleRef, twoImagesTitleVisibility] = useInView();
  const [twoImagesTopRef, twoImagesTopVisibility] = useInView();
  const [twoImagesBottomRef, twoImagesBottomVisibility] = useInView();
  const [officeHeadRef, officeHeadVisibility] = useInView();
  const [officeImageRef, officeImageVisibility] = useInView();
  const [otherProductsTitleRef, otherProductsTitleVisibility] = useInView();

  return (
    <div className="InfiniteProduct353">
      <div className="ProductHeader353">
        <div className="ProductHeader353__container">
          <div className="ProductHeader353__left">
            <div
              className="ProductHeader353__products"
              onClick={() => {
                navigate("/products");
              }}
            >
              Products
            </div>
            <Icon className="ProductHeader353__icon" icon="chevron-right" />
            <div className="ProductHeader353__product">Infinite 353</div>
          </div>
          <div className="ProductHeader353__right">
            <div className="ProductHeader353__design">Design</div>
            <div className="ProductHeader353__features">Features</div>
            <div className="ProductHeader353__specifications">
              Specifications
            </div>
          </div>
        </div>
      </div>
      <div className="ProductImage353">
        <div className="ProductImage353__container">
          <div
            ref={productTitleRef}
            className={cs(
              "ProductImage353__title",
              productTitleVisibility && "ProductImage353__title-animation",
            )}
          >
            Infinite <span>353</span>{" "}
          </div>
          <img
            ref={productImageRef}
            className={cs(
              "ProductImage353__image",
              productImageVisibility && "ProductImage353__image-animation",
            )}
            src={three353}
          />
        </div>
      </div>

      <div className="SixCart353">
        <div className="SixCart353__container">
          <div
            ref={sixCartTitleRef}
            className={cs(
              "SixCart353__title",
              sixCartTitleVisibility && "SixCart353__title-animation",
            )}
          >
            The Game <br /> <span>Changer</span>
          </div>
          <div className="SixCart353__carts">
            <div
              ref={cartOneRef}
              className={cs(
                "SixCart353__cart",
                "SixCart353__cartOne",
                cartOneVisibility && "SixCart353__cartOne-animation",
              )}
            >
              <div className="SixCart353__cartOne-textOne">
                Revolutionary 5G Speed
              </div>
              <img
                loading="lazy"
                src={three353Two}
                className="SixCart353__cartOne-image"
              />
              <div className="SixCart353__cartOne-textTwo">
                Experience hyper-fast 5G speeds that redefine business
                connectivity.
              </div>
            </div>
            <div
              ref={cartTwoRef}
              className={cs(
                "SixCart353__cart",
                "SixCart353__cartTwo",
                cartTwoVisibility && "SixCart353__cartTwo-animation",
              )}
            >
              <div className="SixCart353__cartTwo-textOne">
                Cutting-Edge Chipset
              </div>
              <img loading="lazy" className="SixCart353__cartTwo-image" />
              <div className="SixCart353__cartTwo-textTwo">
                Powered by Snapdragon X65 for peak performance.
              </div>
            </div>
            <div
              ref={cartThreeRef}
              className={cs(
                "SixCart353__cart",
                "SixCart353__cartThree",
                cartThreeVisibility && "SixCart353__cartThree-animation",
              )}
            >
              <div className="SixCart353__cartThree-textOne">
                Supreme Device Capacity
              </div>
              <div className="SixCart353__cartThree-textTwo">
                Seamlessly supports an impressive array of up to 253 devices.
              </div>
            </div>
            <div
              ref={cartFourRef}
              className={cs(
                "SixCart353__cart",
                "SixCart353__cartFour",
                cartFourVisibility && "SixCart353__cartFour-animation",
              )}
            >
              <div className="SixCart353__cartFour-textOne">
                Expansive Coverage
              </div>
              <img
                loading="lazy"
                src={office}
                className="SixCart353__cartFour-image"
              />
              <div className="SixCart353__cartFour-textTwo">
                Optimized antenna technology for wide-reaching, stable
                connections.
              </div>
            </div>
            <div
              ref={cartFiveRef}
              className={cs(
                "SixCart353__cart",
                "SixCart353__cartFive",
                cartFiveVisibility && "SixCart353__cartFive-animation",
              )}
            >
              <div className="SixCart353__cartFive-textOne">
                Smart Network Management
              </div>
              <img
                loading="lazy"
                src={productWavesTop}
                className="SixCart353__cartFive-image"
              />
              <div className="SixCart353__cartFive-textTwo">
                Intuitive controls with smart management features for effortless
                oversight.
              </div>
            </div>
            <div
              ref={cartSixRef}
              className={cs(
                "SixCart353__cart",
                "SixCart353__cartSix",
                cartSixVisibility && "SixCart353__cartSix-animation",
              )}
            >
              <div className="SixCart353__cartSix-textOne">
                Future-Ready Technology
              </div>
              <img loading="lazy" className="SixCart353__cartSix-image" />
              <div className="SixCart353__cartSix-textTwo">
                Equipped with advanced features to future-proof your business
                network.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="RoundLines353">
        <div className="RoundLines353__image-container">
          <img
            ref={roundLinesImageRef}
            loading="lazy"
            src={roundLines}
            className={cs(
              "RoundLines353__image",
              roundLinesImageVisibility && "RoundLines353__image-animation",
            )}
          />
          <div
            ref={roundLinesDescriptionRef}
            className={cs(
              "RoundLines353__description",
              roundLinesDescriptionVisibility &&
                "RoundLines353__description-animation",
            )}
          >
            The new benchmark for 5G performance.
          </div>
        </div>
      </div>

      <div className="WifiSix353">
        <div className="WifiSix353__container">
          <img
            ref={wifiSixTitleRef}
            loading="lazy"
            className={cs(
              "WifiSix353__title",
              wifiSixTitleVisibility && "WifiSix353__title-animation",
            )}
            src={wifi6}
          />
          <div
            ref={wifiSixSubTitleRef}
            className={cs(
              "WifiSix353__subtitle",
              wifiSixSubTitleVisibility && "WifiSix353__subtitle-animation",
            )}
          >
            High-End, Powerful, Exquisite Blazing-Fast WiFi for Top Performance
          </div>
          <div className="WifiSix353__body">
            <img
              ref={wifiSixImageRef}
              loading="lazy"
              className={cs(
                "WifiSix353__image",
                wifiSixImageVisibility && "WifiSix353__image-animation",
              )}
              src={product353}
            />
            {/*<div className="WifiSix353__image-description">*/}
            {/*  Experience a blazing-fast performance with ultra-high speed.*/}
            {/*</div>*/}
          </div>
        </div>
      </div>

      <div className="Qualcomm353">
        <div
          ref={qualcommDescriptionOneRef}
          className={cs(
            "Qualcomm353__descriptionOne",
            qualcommDescriptionOneVisibility &&
              "Qualcomm353__descriptionOne-animation",
          )}
        >
          Empowered by Qualcomm's Snapdragon X65
        </div>
        <img
          ref={qualcommImageRef}
          loading="lazy"
          className={cs(
            "Qualcomm353__image",
            qualcommImageVisibility && "Qualcomm353__image-animation",
          )}
          src={qualcomm}
        />

        <div
          ref={qualcommDescriptionTwoRef}
          className={cs(
            "Qualcomm353__descriptionTwo",
            qualcommDescriptionTwoVisibility &&
              "Qualcomm353__descriptionTwo-animation",
          )}
        >
          Infinite 353 is a powerhouse of 5G speed and efficiency, delivering
          connectivity that enterprises can rely on.
        </div>
      </div>

      <div className="TwoImages353">
        <div className="TwoImages353__container">
          <div
            ref={twoImagesTitleRef}
            className={cs(
              "TwoImages353__title",
              twoImagesTitleVisibility && "TwoImages353__title-animation",
            )}
          >
            Adaptive Excellence <br /> Pioneering Connectivity
          </div>
          <div
            ref={twoImagesTopRef}
            className={cs(
              "TwoImages353__top",
              twoImagesTopVisibility && "TwoImages353__top-animation",
            )}
          >
            <img
              loading="lazy"
              className="TwoImages353__top-image"
              src={product353Wallpaper}
            />
            <div className="TwoImages353__top-text">
              <div className="TwoImages353__top-text-one">
                Unmatched Efficiency
              </div>
              <div className="TwoImages353__top-text-two">
                Infinite 353's 'Adaptive Connectivity Enhancement' intelligently
                fine-tunes network performance in real-time for unparalleled
                efficiency, distinguishing it from rivals with a superior,
                smooth experience.
              </div>
            </div>
          </div>
          <div
            ref={twoImagesBottomRef}
            className={cs(
              "TwoImages353__bottom",
              twoImagesBottomVisibility && "TwoImages353__bottom-animation",
            )}
          >
            <div className="TwoImages353__bottom-text">
              <div className="TwoImages353__bottom-text-one">
                Leading with Intelligence
              </div>
              <div className="TwoImages353__bottom-text-two">
                The Infinite 353 redefines connectivity, adapting in real-time
                to your evolving business needs for unmatched stability and
                quality. It exemplifies our commitment to leading with
                future-ready solutions.
              </div>
            </div>
            <img
              loading="lazy"
              className="TwoImages353__bottom-image"
              src={productPorts}
            />
          </div>
        </div>
      </div>

      <div className="Office353">
        <div className="Office353__container">
          <div
            ref={officeHeadRef}
            className={cs(
              "Office353__head",
              officeHeadVisibility && "Office353__head-animation",
            )}
          >
            <div className="Office353__head-left">Empower Your Network</div>
            <div className="Office353__head-right">
              <div className="Office353__head-right-left">+250</div>
              <div className="Office353__head-right-right">
                The Infinite 353 offers seamless support for users and devices,
                ensuring a robust, scalable network for smooth operations and
                exceptional experiences.
              </div>
            </div>
          </div>
          <img
            ref={officeImageRef}
            loading="lazy"
            className={cs(
              "Office353__image",
              officeImageVisibility && "Office353__image-animation",
            )}
            src={office}
          />
        </div>
      </div>

      <div className="Specifications353">
        <div className="Specifications353__container">
          <div className="Specifications353__title">Specifications</div>
          <div className="Specifications353__subtitle">Hardware</div>
          <div className="Specifications353__section">
            <div className="Specifications353__section-left">
              <div className="Specifications353__section-title">5G Chipset</div>
            </div>
            <div className="Specifications353__section-right">
              <div
                className={cs(
                  "Specifications353__section-description",
                  "Specifications353__section-description-borderNone",
                )}
              >
                5G Qualcomm SDX65
              </div>
            </div>
          </div>
          <div className="Specifications353__section">
            <div className="Specifications353__section-left">
              <div className="Specifications353__section-title">
                Wi-Fi Chipset
              </div>
            </div>
            <div className="Specifications353__section-right">
              <div className="Specifications353__section-description">
                Wi-Fi 6 Qualcomm IPQ5018 + QCM6024
              </div>
              <div className="Specifications353__section-description">
                2T2R 2.4GHz 802.11b/g/n/ac/ax, 573.5Mbps
              </div>
              <div className="Specifications353__section-description">
                4T4R 5GHz 802.11a/n/ac/ax, 4804Mbps
              </div>
              <div
                className={cs(
                  "Specifications353__section-description",
                  "Specifications353__section-description-borderNone",
                )}
              >
                3 x 2 dBi internal 2.4G&5G dual band antenna
              </div>
            </div>
          </div>

          <div className="Specifications353__section">
            <div className="Specifications353__section-left">
              <div className="Specifications353__section-title">
                Device Interfaces
              </div>
            </div>
            <div className="Specifications353__section-right">
              <div className="Specifications353__section-description">
                1 x 1Gbps LAN-Ethernet
              </div>
              <div className="Specifications353__section-description">
                1 x 2.5Gbps WAN-Ethernet
              </div>
              <div className="Specifications353__section-description">
                1 x Power jack
              </div>{" "}
              <div className="Specifications353__section-description">
                1 x Phone jack
              </div>
              <div
                className={cs(
                  "Specifications353__section-description",
                  "Specifications353__section-description-borderNone",
                )}
              >
                Maximum Concurrent Users – 253 Devices
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ImageSlider353">
        <FlickitySlider
          options={{
            lazyLoad: 10,
            wrapAround: true,
            contain: true,
            draggable: true,
            autoPlay: true,
            freeScroll: true,
            imagesLoaded: true,
            prevNextButtons: false,
          }}
        >
          <div className="ImageSlider353__image-container">
            <img
              loading="lazy"
              className="ImageSlider353__image"
              data-flickity-lazyload={product353Wallpaper}
            />
          </div>
          <div className="ImageSlider353__image-container">
            <img
              loading="lazy"
              className="ImageSlider353__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider353__image-container">
            <img
              loading="lazy"
              className="ImageSlider353__image"
              data-flickity-lazyload={product353Wallpaper}
            />
          </div>
          <div className="ImageSlider353__image-container">
            <img
              loading="lazy"
              className="ImageSlider353__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
        </FlickitySlider>
      </div>

      <div className="OtherProducts353">
        <div className="OtherProducts353__container">
          <div
            ref={otherProductsTitleRef}
            className={cs(
              "OtherProducts353__title",
              otherProductsTitleVisibility &&
                "OtherProducts353__title-animation",
            )}
          >
            Other Products
          </div>
          <OtherProducts />
        </div>
      </div>
    </div>
  );
};

export default Infinite353;
